import { render, staticRenderFns } from "./TestimonialsList.vue?vue&type=template&id=909e12d8"
import script from "./TestimonialsList.vue?vue&type=script&lang=js"
export * from "./TestimonialsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports